<template>
  <div class="page_container">
    <!--  主要内容 start -->
    <div class="form_container">
      <div class="content_wrap">
        <div class="banner_wrap">
          <van-swipe class="my-swipe" :autoplay="3000" indicator-color="white">
            <van-swipe-item v-for="(item, index) in bannerList" :key="index">
              <van-image width="100%" height="100%" fit="cover" :src="item" />
            </van-swipe-item>
          </van-swipe>
        </div>
        <div class="baseinfo">
          <div class="tit">{{ dataItem.at_topic }}</div>
          <div class="tags flex-rowl">
            <div
              v-for="(item, index) in dataItem.typeidArr"
              :key="index"
              class="tag"
            >
              #{{ item }}
            </div>
          </div>
          <div class="data">{{ dataItem.createdate | formatDate }}</div>
          <div class="intro_slide_state">
            <div class="txt">
              图文简介：<span>{{ dataItem.at_intro }}</span>
            </div>
            <div class="txt">
              关联货架：<span>{{ dataItem.slidstr }}</span>
            </div>
            <div class="txt">
              审核状态：<span>{{ dataItem.checkstate }}</span>
            </div>
          </div>
        </div>
        <div class="detail_wrap">
          <div class="tit">图文详情：</div>
          <div
            class="detail_item"
            v-for="(item, index) in contentList"
            :key="index"
          >
            <template v-if="item.conttype == 1">
              <div class="image_box">
                <img :src="item.picurl" alt="" />
              </div>
            </template>
            <template v-if="item.conttype == 2">
              <div class="video_box">
                <video :src="item.videourl" controls></video>
              </div>
            </template>
            <template v-if="item.conttype == 3">
              <div class="txt">
                {{ item.details }}
              </div>
            </template>
          </div>
        </div>
      </div>
    </div>
    <div class="fixd_button_btm flex-rowl">
      <div class="item return" @click="handleReturn">返回</div>
      <div class="item" @click="handleEdit">审核</div>
    </div>
    <!--  主要内容 end -->
  </div>
</template>

<script>
import { encryptstringview, encryptstringadd } from "../../api/api";
import { getArticleDetail } from "../../api/article";
import { mapState } from "vuex";
export default {
  name: "cBacklogDetail",
  data() {
    return {
      loading: false,
      qyid: "",
      dataItem: "",
      type: "",
      id: "",
      bannerList: [],
      contentList: [], // 主要内容
    };
  },
  filters: {
    // 时间格式化
    formatDate(date) {
      if (!date) return "";
      if (date.indexOf("T") != -1) {
        let dateSplit = date.split("T");
        let dataTime =
          dateSplit[1].indexOf(".") != -1
            ? dateSplit[1].split(".")[0]
            : dateSplit[1];
        return dateSplit[0] + " " + dataTime; // 这里可以根据需要使用不同的日期格式化选项
      } else {
        return date;
      }
    },
  },
  computed: {
    ...mapState(["OPENID"]),
  },
  created() {
    let { routerList, OPENID, USERINFO } = this.$store.state;
    let { name } = this.$route;
    if (USERINFO.qy) {
      this.qyid = USERINFO.qy.qyid;
    } else {
      this.qyid = 0;
    }

    // 判断是有有参数需要解密 this.$route中的name和state.routerList对象
    if (name in routerList) {
      if (routerList[name].encryptstring == "") return;
      this.encryptstringview(routerList[name].encryptstring, OPENID);
    }
  },
  methods: {
    // 通过解密获取参数
    async encryptstringview(encryptstring, openid) {
      let res = await encryptstringview({ openid, encryptstring });
      if (res.result) {
        let { id } = JSON.parse(res.jsondata);
        this.id = id;
        this.getArticleDetail(id);
      } else {
        this.$router.back();
      }
    },

    // 获取图文详情
    getArticleDetail(id) {
      const Toast = this.$toast.loading({
        message: "加载中...",
        forbidClick: true,
      });
      getArticleDetail({ id }).then((res) => {
        // banner 的转换
        let bannerList = Object.keys(res)
          .filter((key) => key.startsWith("banner") && res[key]) // 添加条件检查属性值是否非空
          .map((key) => res[key]);
        // 将封面的图新增到banner中
        bannerList.unshift(res.at_pic);
        res.typeidArr = res.typeidstr.split(",");
        this.dataItem = res;
        this.bannerList = bannerList;
        this.contentList = res.videopic;
        Toast.clear();
      });
    },

    handleReturn() {
      this.$router.back();
    },

    handleEdit() {
      this.encryptstringadd("articleEdit", { id: this.id });
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },
  },
};
</script>
<style lang="less" scoped>
.page_container {
  padding-bottom: 240px;
  .banner_wrap {
    height: 900px;
    width: 100%;
    .my-swipe {
      height: 100%;
    }
  }
  .baseinfo {
    padding: 50px 45px;
    .tit {
      font-size: 28px;
      color: #4C4C4C;
    }
    .tags {
      font-size: 22px;
      color: #236F96;
      margin: 9px 0 20px;
      .tag {
        margin-right: 10px;
      }
    }
    .data {
      font-size: 20px;
      color: #A1A1A1;
      margin-bottom: 15px;
    }
    .intro_slide_state {
      font-size: 24px;
      .txt {
        &:nth-child(2) {
          margin: 10px 0;
        }
      }
      span {
        font-size: 20px;
      }
    }
  }
  .detail_wrap {
    margin: 0 45px;
    .tit {
      font-size: 26px;
      margin-bottom: 25px;
    }
    .detail_item {
      font-size: 20px;
      margin-bottom: 10px;
      .image_box {
        width: 100%;
        img {
          width: 100%;
        }
      }
      .video_box {
        width: 100%;
        video {
          width: 100%;
        }
      }
    }
  }
}
</style>